module.exports = __webpack_public_path__ + "static/media/findDoctorNearMe.f38b0020.svg";